import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHolisticlock } from "../../entity/EntityHolisticlock";

export class DtoHolisticlocksGetRes extends EntityHolisticlock {
  public items: EntityHolisticlock[]  = [];
}
